import * as types from '../constants/signup';

// SIGNUP
export const apiSignupRequest = (data, socialType = null) => ({
  type: types.API_SIGNUP_REQUEST,
  data,
  socialType,
});

export const setSuccess = payload => ({
  type: types.SET_SUCCESS,
  payload,
});

export const apiSignupRequestSuccess = response => ({
  type: types.API_SIGNUP_REQUEST_SUCCESS,
  response,
});

export const apiSignupRequestFailed = response => ({
  type: types.API_SIGNUP_REQUEST_FAILED,
  response,
});

export const apiChangePasswordRequest = (token, data) => ({
  type: types.API_CHANGE_PASSWORD_REQUEST,
  token,
  data,
});
export const apiChangePasswordSuccess = response => ({
  type: types.API_CHANGE_PASSWORD_SUCCESS,
  response,
});
export const apiChangePasswordFailed = response => ({
  type: types.API_CHANGE_PASSWORD_FAILED,
  response,
});

export const apiUserConfirmationRequest = confirmationCode => ({
  type: types.API_USER_CONFIRMATION_REQUEST,
  confirmationCode,
});
export const apiUserConfirmationSuccess = response => ({
  type: types.API_USER_CONFIRMATION_SUCCESS,
  response,
});
export const apiUserConfirmationFailed = payload => ({
  type: types.API_USER_CONFIRMATION_FAILED,
  payload,
});

// Resend the signup confirmation link
export const apiResendConfirmationRequest = email => ({
  type: types.API_RESEND_CONFIRMATION_REQUEST,
  email,
});
export const apiResendConfirmationSuccess = payload => ({
  type: types.API_RESEND_CONFIRMATION_SUCCESS,
  payload,
});
export const apiResendConfirmationFailed = payload => ({
  type: types.API_RESEND_CONFIRMATION_FAILED,
  payload,
});
export const resetResendConfirmation = () => ({
  type: types.RESET_RESEND_CONFIRMATION,
});

// Google-only account asks for a link to set its first password
export const apiSetPasswordRequest = token => ({
  type: types.API_SET_PASSWORD_REQUEST,
  token,
});
export const apiSetPasswordSuccess = payload => ({
  type: types.API_SET_PASSWORD_SUCCESS,
  payload,
});
export const apiSetPasswordFailed = payload => ({
  type: types.API_SET_PASSWORD_FAILED,
  payload,
});
